import * as React from 'react';

import FileIndesign32 from './FileIndesign32';

export const fileIndesign32 = () => <FileIndesign32 />;

export default {
    title: 'Icon|Content|FileIndesign32',
    component: FileIndesign32,
    parameters: {
        notes: "`import FileIndesign32 from 'box-ui-elements/es/icon/content/FileIndesign32';`",
    },
};
